import {
  type CurrentRefinementsConnectorParamsItem,
  type CurrentRefinementsConnectorParamsRefinement,
} from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';

type TransformedRefinements = {
  [key: string]: string | number | boolean | (string | number | boolean)[];
};

export const transformRefinements = (refinements: CurrentRefinementsConnectorParamsItem[]): TransformedRefinements => {
  return refinements.reduce((acc: TransformedRefinements, refinement: CurrentRefinementsConnectorParamsItem) => {
    refinement.refinements.forEach((item: CurrentRefinementsConnectorParamsRefinement) => {
      acc[item.attribute] = item.value;
    });
    return acc;
  }, {});
};
